import $foreign from "./foreign.cjs";
var mkEffectFn1 = $foreign.mkEffectFn1;
var mkEffectFn10 = $foreign.mkEffectFn10;
var mkEffectFn2 = $foreign.mkEffectFn2;
var mkEffectFn3 = $foreign.mkEffectFn3;
var mkEffectFn4 = $foreign.mkEffectFn4;
var mkEffectFn5 = $foreign.mkEffectFn5;
var mkEffectFn6 = $foreign.mkEffectFn6;
var mkEffectFn7 = $foreign.mkEffectFn7;
var mkEffectFn8 = $foreign.mkEffectFn8;
var mkEffectFn9 = $foreign.mkEffectFn9;
var runEffectFn1 = $foreign.runEffectFn1;
var runEffectFn10 = $foreign.runEffectFn10;
var runEffectFn2 = $foreign.runEffectFn2;
var runEffectFn3 = $foreign.runEffectFn3;
var runEffectFn4 = $foreign.runEffectFn4;
var runEffectFn5 = $foreign.runEffectFn5;
var runEffectFn6 = $foreign.runEffectFn6;
var runEffectFn7 = $foreign.runEffectFn7;
var runEffectFn8 = $foreign.runEffectFn8;
var runEffectFn9 = $foreign.runEffectFn9;
export { mkEffectFn1, mkEffectFn10, mkEffectFn2, mkEffectFn3, mkEffectFn4, mkEffectFn5, mkEffectFn6, mkEffectFn7, mkEffectFn8, mkEffectFn9, runEffectFn1, runEffectFn10, runEffectFn2, runEffectFn3, runEffectFn4, runEffectFn5, runEffectFn6, runEffectFn7, runEffectFn8, runEffectFn9 };
